import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import './style.css'
import './fontsize/icon.css'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import router from './router/router'
console.log(import.meta.env.VITE_APP_ENV, '环境');
const pinia = createPinia()
const app = createApp(App)
app.directive('global-click', {
    // 元素挂载前执行
    beforeMount(el, binding) {
        // 获取元素原始的@click处理函数
        const originalHandler = binding.value;
        // 创建包裹函数
        el._clickHandler = (e: any) => {
            let data = localStorage.getItem('userinfo')
            let newdata = JSON.parse(data)
            // 权限判断示例
            if (newdata.status !== 1) {
                ElMessage.warning('请先填写企业认证信息')
                e.stopPropagation(); // 阻止事件冒泡
                return;
            } else {
                // 执行原始处理函数
                console.log('触发了全局点击事件');
                originalHandler(e);
            }
            // 公共处理逻辑
            // logClickEvent(el);
        };
        // 绑定新的事件监听
        el.addEventListener('click', el._clickHandler);
    },
    // 元素卸载时清理
    unmounted(el) {
        el.removeEventListener('click', el._clickHandler);
    }
});
// 挂载路由
app.use(router)
app.use(ElementPlus)
app.use(pinia)
app.mount('#app')

